// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see CreditLineBorrowStartEvent
 */
export var CreditLineBorrowStart = function (_a) {
    var source = _a.source, creditLineToken = _a.creditLineToken;
    return ({
        name: "CreditLine Borrow Start",
        parameters: {
            cdf_entity: "CreditLine",
            cdf_action: "Borrow",
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            credit_line_token: creditLineToken !== undefined && creditLineToken !== null ? creditLineToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CreditLineViewManageEvent
 */
export var CreditLineViewManage = function (_a) {
    var source = _a.source, creditLineToken = _a.creditLineToken;
    return ({
        name: "CreditLine View Manage",
        parameters: {
            cdf_entity: "CreditLine",
            cdf_action: "View",
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            credit_line_token: creditLineToken !== undefined && creditLineToken !== null ? creditLineToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CreditLineViewLoadCreditLimitEvent
 */
export var CreditLineViewLoadCreditLimit = function (_a) {
    var source = _a.source;
    return ({
        name: "CreditLine View LoadCreditLimit",
        parameters: {
            cdf_entity: "CreditLine",
            cdf_action: "View",
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CreditLineViewOpenLoanDetailsEvent
 */
export var CreditLineViewOpenLoanDetails = function (_a) {
    var creditLineToken = _a.creditLineToken, loanToken = _a.loanToken;
    return ({
        name: "CreditLine View OpenLoanDetails",
        parameters: {
            cdf_entity: "CreditLine",
            cdf_action: "View",
            credit_line_token: creditLineToken !== undefined && creditLineToken !== null ? creditLineToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            loan_token: loanToken !== undefined && loanToken !== null ? loanToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CreditLineViewCheckCreditLimitEvent
 */
export var CreditLineViewCheckCreditLimit = function (_a) {
    var creditLineToken = _a.creditLineToken, creditLimitCents = _a.creditLimitCents;
    return ({
        name: "CreditLine View CheckCreditLimit",
        parameters: {
            cdf_entity: "CreditLine",
            cdf_action: "View",
            credit_line_token: creditLineToken !== undefined && creditLineToken !== null ? creditLineToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            credit_limit_cents: creditLimitCents !== undefined && creditLimitCents !== null ? creditLimitCents.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CreditLineAccessStartEvent
 */
export var CreditLineAccessStart = function (_a) {
    var creditLineToken = _a.creditLineToken;
    return ({
        name: "CreditLine Access Start",
        parameters: {
            cdf_entity: "CreditLine",
            cdf_action: "Access",
            credit_line_token: creditLineToken !== undefined && creditLineToken !== null ? creditLineToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CreditLineRepayStartEvent
 */
export var CreditLineRepayStart = function (_a) {
    var state = _a.state, source = _a.source, loanToken = _a.loanToken, creditLineToken = _a.creditLineToken, transactionToken = _a.transactionToken;
    return ({
        name: "CreditLine Repay Start",
        parameters: {
            cdf_entity: "CreditLine",
            cdf_action: "Repay",
            state: state !== undefined && state !== null ? state.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            loan_token: loanToken !== undefined && loanToken !== null ? loanToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            credit_line_token: creditLineToken !== undefined && creditLineToken !== null ? creditLineToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            transaction_token: transactionToken !== undefined && transactionToken !== null ? transactionToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
